// removed by extract-text-webpack-plugin
module.exports = {"row":"App-row-ba4fbfe6","col":"App-col-c7bc2927","button":"App-button-49c9b3b5","bannerAd":"App-bannerAd-795f732a","rail":"App-rail-c2211159","app":"App-app-21db1c1e","content":"App-content-e9e5f3cb","footer":"App-footer-dc7ce21b"};


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 902
// module chunks = 0